import Submission from './Submission';

export default Submission;
